import {useState,useEffect} from 'react';
import { 
    Grid, Paper,Stack,Button, Icon, Tooltip, IconButton,
     LinearProgress,FormGroup,FormControlLabel,Checkbox
    
    } from '@mui/material';
import DataTable, { ExpanderComponentProps,TableRow }  from 'react-data-table-component';

import {Link as RLink} from 'react-router-dom';
import ListFilter from './ListFilter';

// import elp from '../../services/elp';
import ConfigurationTM from '../../services/ConfigurationTM';
import u from '../../services/util';
import ModalDialog from '../../components/ModalDialog';
import { DummyData } from './DummyData';
import ValidatorEnginnerForm from './ValidatorForm';
import "./Configuration-services.css"
import moment from 'moment';


function ApproverList(props){
    const initData = {rows:[],count:0,page:1};
    
    const[ELPmodel, setELPmodel] = useState<any>({show:false,id:null});

    const [data,setData] = useState<any>(initData);
    const [Filter,setFilter] = useState<any>({page:1});
    const [loading,setloading] = useState<boolean>(false);
    const [tableRow,setTableRow] = useState<any>(null)
    const [selectedArr,setSelectedArr] = useState<any>([])
    const [processing,setProcessing] = useState(false)

    const handleSelectArr = (isCheck,row)=>{
        const   newArr = [...selectedArr];                 
        if(isCheck){

            newArr.push(row)
            setSelectedArr(newArr)
        }
        else{
              const updatedArr= newArr.filter(item=>item.ID!==row.ID)
              setSelectedArr(updatedArr)
// console.log(updatedArr)
        }

    }

    const handlerFilterChange = (filter:any)=>{
        setFilter({...filter});
    }

    const onPagingChange = (page:number)=>{
        setFilter({...Filter,page:page});
    }

    const load = async()=>{
        setloading(true);
        
        let res:any = await ConfigurationTM.approverList({...Filter});
        if(res.success){
            setData(res.data)
        }
        setloading(false);
        // let test:any = await ConfigurationTM.test({...Filter});
    }

    useEffect(() => {
        if(Object.keys(Filter).length > 0)
            load();
            
    }, [Filter])

    const handlerOnShowELPmodel = (id:string|null)=> setELPmodel({show:true,id:id})
    const handlerOnCloseELPmodel = ()=> {

        setELPmodel({show:false,id:null});
        load();
    }
    const handlerCloseAndRefresh = ()=>{
        handlerOnCloseELPmodel();
        load();
    }
    
    const columns:any = [
        {
            name: 'ID',
            selector: 'ID',
            compact:true,
            width:'50px',
        },
        {
            name: 'Customer Domain',
            selector: 'CustomerDomain',
            compact:true,
            // hide:1200,
        },
        {
            name: 'Start Date',
            selector: 'StartDate',
            compact:true,
            cell:(row:any)=> moment(row.StartDate, "MM-DD-YYYY").format('MMM DD, YYYY')
            //  row.StartDate?u.format.datetime(row.StartDate):''
            
            //hide:1200,
        },
        
        {
            name: 'End Date',
            selector: 'EndDate',
            compact:true,
            cell:(row:any)=> moment(row.EndDate, "MM-DD-YYYY").format('MMM DD, YYYY')
            // row.EndDate || ""
            // row.EndDate?u.format.datetime(row.EndDate):''
            //  moment(row?.EndDate).format('DD MMM, YYYY')
            //width:'230px'
            //hide:1200,
        },
        
        {
            name: 'T&M Count',
            selector: 'hours',
            compact:true,
            // cell:(row:any)=> JSON.parse(row?.TmCount).toString()
            cell:(row:any)=>{ 
                let counts = JSON.parse(row?.TmCount).toString();
                let  convertToNumbersArray = counts.split`,`.map(x=>+x)
                let result = 0;
                for (let i = 0; i < convertToNumbersArray.length; i++) {
                  result += convertToNumbersArray[i];
                }
  
                return result;
              }
            // width:'60px',
            //hide:1200,
        },
        {
            name: 'Notes',
            selector: 'Summary',
            compact:true,
            width:'200px',
            left:true,
            
            //hide:1200,
        },
        {
            name: 'Status',
            selector: 'Status',
            compact:true,
            right:true,
            cell:(row:any)=> row.CurrentState === 'pending_internal_approval' ? 'Pending Internal Approval' : 'Approved',
            // width:'70px',
            //hide:1200,
        },
        
        {
            name: 'Date Created',
            selector: 'CreatedAt',
            compact:true,
            right:true,
            // width:'100px',
            cell:(row:any)=> row.CreatedAt?u.format.datetime(row.CreatedAt):''
            //hide:1200,
        },
        
        {
            name: 'Actions',
            //selector: 'MPID',
            compact:true,
            // width:'60px',
            right:true,
            cell:(row:any) => 
                <>
                    
                                       <FormGroup>
                                       <FormControlLabel
                                         control={<Checkbox
                                        //    checked={cert.value}
                                           onChange={(e) => {
                                            handleSelectArr(e.target.checked,row);
                                           } }
                                            />}
                                        //  label={`Add ${cert.name} certification`} 
                                         />
                                     </FormGroup>

                                     <Tooltip title="View">
                        <IconButton size="small" className="action" 
                            onClick={()=>{
                                setTableRow(row)
                                handlerOnShowELPmodel(row.ID);

                            }}>
                            <Icon className="icon-blue">visibility</Icon>
                        </IconButton>
                    </Tooltip>
                  
                </>
          }
      ];

      const handleSubmit = async (mode:any) => {
        setProcessing(true);
  
        let res: any = null;
        
        // res = await ConfigurationTM.bulkCreateApprovals({
        //   ...selectedArr,
        //   approved:mode=== 'Approved'?true:false,
        // })
        // if (!res.success) {
        //   window.snakAlert.error(res.message);
        // } else {
        //   if (res.success && res.data) {
        //     handlerOnCloseELPmodel()
        //     window.snakAlert.success(res.data);
        //   } else {
        //     window.snakAlert.error(res.message);
        //   }
        // }
        res = await ConfigurationTM.bulkCreateApprovals({
            data:selectedArr.map(v => ({...v, approved:mode=== 'Approved'?true:false,})),
  
          })
        if (!res.success) {
          window.snakAlert.error(res.data.message);
        } else {
          if (res.success && res.data) {
            handlerOnCloseELPmodel()
            window.snakAlert.success(res.data.message);
          } else {
            window.snakAlert.error(res.data.message);
          }
        }
        setProcessing(false);
    
      };
    return(
        <>
        <div className="page-content">
            <Grid container spacing={2}>
                <Grid item md={5} lg={6} xs={12}>
                    <h2>Approver<span>List of all Approvals</span></h2>
                </Grid>
            </Grid>

            <Paper elevation={1} className="section mt-10">
                <ListFilter noNewConfig onChangeFilter={handlerFilterChange} onShowELPModel={()=>{handlerOnShowELPmodel(null)}} />
            </Paper>
            
            {loading && <LinearProgress className="mt--4"/>}

            <Paper elevation={1} className="section mt-14" style={{minHeight:'43rem'}}>
                <DataTable className='table'
                    title=""
                    noHeader={true}
                    columns={columns}
                    dense={true}
                    
                    data={data?.rows}
                    highlightOnHover={true}
                    pagination={true}
                    paginationServer={true}
                    paginationTotalRows={data?.rows?.length}
                    paginationPerPage={20}
                    paginationComponentOptions={ {noRowsPerPage: true}}
                    paginationDefaultPage={Filter.page}
                    //paginationResetDefaultPage={!Filter.page}
                    onChangePage={(page:number)=>{onPagingChange(page)}}
                    //expandableRows 
                    //expandableRowsComponent={ExpandedComponent}
                    //conditionalRowStyles={conditionalRowStyles}
                />   
                {/* {
                    data?.rows.length ? (
                        <>
                   <Button style={{float:'right'}} size="large" variant="contained" color="primary" 
                onClick={()=>handleSubmit('Reject')}
                   >
                            Reject
                        </Button>   
                   <Button style={{float:'right',marginRight:'10px'}} size="large" variant="contained" color="primary" 
                   onClick={()=>handleSubmit('Approved')}
                   
                   >
                            Approved
                        </Button>   
                        
                        </>
                    ):null
                } */}

            </Paper>
            



        </div>
        
        <ModalDialog
            fullScreen={true}   
            title={`Approved or Reject T&M Configuration`}
            // component={<ConfigurationForm handlerOnCloseELPmodel={handlerOnCloseELPmodel}/>}
            component={<ValidatorEnginnerForm data={tableRow} handlerOnCloseELPmodel={handlerOnCloseELPmodel}/>}
            open={ELPmodel.show}
            onClose={handlerOnCloseELPmodel}
        />

    </>
    )
}

export default ApproverList